const mutations = {
  SET_KEY_STATISTICS(state, payload) {
    state.asOfdate = payload.AsOfDate;
    state.averageLife = payload.AverageLife;
    state.effectiveDuration = payload.EffectiveDuration;
    state.yieldToMaturity = payload.AverageYieldToMaturity;
    state.yieldToWorst = payload.YieldToWorst;
    state.averageCoupon = payload.AverageCoupon;
    state.optionAdjustedSpread = payload.OptionAdjustedSpread;
  }
};
const getters = {
  keyStatistics_asOfDate: state => state.asOfdate,
  keyStatistics_averageLife: state => state.averageLife,
  keyStatistics_effectiveDuration: state => state.effectiveDuration,
  keyStatistics_yieldToMaturity: state => state.yieldToMaturity,
  keyStatistics_yieldToWorst: state => state.yieldToWorst,
  keyStatistics_averageCoupon: state => state.averageCoupon,
  keyStatistics_optionAdjustedSpread: state => state.optionAdjustedSpread
};

const state = {
  asOfdate: null,
  averageLife: null,
  effectiveDuration: null,
  yieldToMaturity: null,
  yieldToWorst: null,
  averageCoupon: null,
  optionAdjustedSpread: null
};

export default {
  state,
  getters,
  mutations
};
